/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const ChevronLeft = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 4 7">
      <path
        d="M0.5,7 C0.372,7 0.244,6.951 0.146,6.854 C-0.049,6.658 -0.049,6.342 0.146,6.146 L2.793,3.5 L0.146,0.854 C-0.049,0.658 -0.049,0.342 0.146,0.146 C0.342,-0.049 0.658,-0.049 0.854,0.146 L3.854,3.146 C4.049,3.342 4.049,3.658 3.854,3.854 L0.854,6.854 C0.756,6.951 0.628,7 0.5,7"
        transform="matrix(-1 0 0 1 4 0)"
      />
    </BaseSvgIcon>
  )
}

export default ChevronLeft
